// Function to parse date, including time, to time
export function extractStringTimeFromDate(date: Date): string {

    // Get time in format HH:MM:SS
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');

    // Format the time
    return `${hours}:${minutes}`;
}
